module.exports = __webpack_public_path__ + "static/media/069f5eff.jpg";